<template>
  <Login />
</template>

<script>
import Login from '@/components/pages/account/Login'

export default {
  components: {
    Login
  }
}
</script>
